import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StfNgSelectButtonComponent } from './stf-ng-select/stf-ng-select-button.component';
import { StfNgSelectOptionComponent } from './stf-ng-select/stf-ng-select-option.component';
import { StfNgSelectComponent } from './stf-ng-select/stf-ng-select.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    StfNgSelectComponent,
    StfNgSelectOptionComponent,
    StfNgSelectButtonComponent,
  ],
  exports: [
    StfNgSelectComponent,
    StfNgSelectOptionComponent,
    StfNgSelectButtonComponent,
  ],
})
export class StfNgSelectModule { }
